module.exports = __webpack_public_path__ + "img/finish_point.e5bf35ad.png";